import { Helpers } from '../../helpers';
import { IResourceCalculation } from '../../interfaces/iresource-calculation';
import { Equation } from '../equation';
import { GeneralAttributeRateKey } from '../general-attribute-rate-key';
import { GeneralAttributeResourceCalculationKey } from '../general-attribute-resource-calculation-key';
import { ItemAttributeRateKey } from '../item-attribute-rate-key';
import { ItemAttributeResourceCalculationKey } from '../item-attribute-resource-calculation-key';
import { ItemCategory } from '../item-category';
import { ResourceCategory } from '../resource-category';
import { ScheduleTaskAttributeRateKey } from '../schedule-task-attribute-rate-key';
import { ScheduleTaskAttributeResourceCalculationKey } from '../schedule-task-attribute-resource-calculation-key';

export class ResourceCalculationBase {
  ResourceCalculationId: number;
  ItemCategoryId: number | null;
  ResourceCategoryId: number | null;
  EquationId: number | null;
  EquationValue: string | null;
  IsSynced: boolean | null;
  LastUpdatedUser: string | null;
  LastUpdatedDate: Date | null;
  IsActive: boolean | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  GeneralAttributeRateKeys_ResourceCalculation?: Array<GeneralAttributeRateKey> | null;
  GeneralAttributeResourceCalculationKeys_ResourceCalculation?: Array<GeneralAttributeResourceCalculationKey> | null;
  ItemAttributeRateKeys_ResourceCalculation?: Array<ItemAttributeRateKey> | null;
  ItemAttributeResourceCalculationKeys_ResourceCalculation?: Array<ItemAttributeResourceCalculationKey> | null;
  ScheduleTaskAttributeRateKeys_ResourceCalculation?: Array<ScheduleTaskAttributeRateKey> | null;
  ScheduleTaskAttributeResourceCalculationKeys_ResourceCalculation?: Array<ScheduleTaskAttributeResourceCalculationKey> | null;
  Equation?: Equation;
  ItemCategory?: ItemCategory;
  ResourceCategory?: ResourceCategory;

  constructor(item?: IResourceCalculation) {
    if (item) {

      this.ResourceCalculationId = item.ResourceCalculationId;
      this.ItemCategoryId = item.ItemCategoryId;
      this.ResourceCategoryId = item.ResourceCategoryId;
      this.EquationId = item.EquationId;
      this.EquationValue = item.EquationValue;
      this.IsSynced = item.IsSynced;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.IsActive = item.IsActive;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.GeneralAttributeRateKeys_ResourceCalculation = Helpers.createClassArray(GeneralAttributeRateKey, item.GeneralAttributeRateKeys_ResourceCalculation);
      this.GeneralAttributeResourceCalculationKeys_ResourceCalculation = Helpers.createClassArray(GeneralAttributeResourceCalculationKey, item.GeneralAttributeResourceCalculationKeys_ResourceCalculation);
      this.ItemAttributeRateKeys_ResourceCalculation = Helpers.createClassArray(ItemAttributeRateKey, item.ItemAttributeRateKeys_ResourceCalculation);
      this.ItemAttributeResourceCalculationKeys_ResourceCalculation = Helpers.createClassArray(ItemAttributeResourceCalculationKey, item.ItemAttributeResourceCalculationKeys_ResourceCalculation);
      this.ScheduleTaskAttributeRateKeys_ResourceCalculation = Helpers.createClassArray(ScheduleTaskAttributeRateKey, item.ScheduleTaskAttributeRateKeys_ResourceCalculation);
      this.ScheduleTaskAttributeResourceCalculationKeys_ResourceCalculation = Helpers.createClassArray(ScheduleTaskAttributeResourceCalculationKey, item.ScheduleTaskAttributeResourceCalculationKeys_ResourceCalculation);
      this.Equation = new Equation(item.Equation);
      this.ItemCategory = new ItemCategory(item.ItemCategory);
      this.ResourceCategory = new ResourceCategory(item.ResourceCategory);
    }
  }
}